import { createSelector } from '@ngrx/store';

import { productRestrictionsState } from '../root';

export const getProductRestrictions = createSelector(productRestrictionsState, (productRestrictions) => productRestrictions);
